module.exports = __webpack_public_path__ + "static/img/indexbg1.9df82c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/indexbg1.jpg
// module id = GQSn
// module chunks = 1